import { render } from "./indicadorAluno.vue?vue&type=template&id=d962931a&scoped=true"
import script from "./indicadorAluno.vue?vue&type=script&lang=js"
export * from "./indicadorAluno.vue?vue&type=script&lang=js"

import "./indicadorAluno.vue?vue&type=style&index=0&id=d962931a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d962931a"]])

export default __exports__